import { IconProps } from './types';

export function Burger(props: IconProps) {
  const size = props.size ?? 30;
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect y="6.5" width={size} height="3" fill="currentColor" />
      <rect y="13.5" width={size} height="3" fill="currentColor" />
      <rect y="20.5" width={size} height="3" fill="currentColor" />
    </svg>
  );
}
